import { Toast } from 'mint-ui'

export const onceToast = {
  data () {
    return {
      toastObj: null
    }
  },
  methods: {
    onceToast (payload) {
      this.toastObj && this.toastObj.close()
      this.toastObj = Toast(payload)
    }
  }
}
